import { FEATURE_TYPE } from '@/constants/features';
import { FeatureLike } from 'ol/Feature';
import type { MapClickTarget, MarkerType } from 'minerva-plugin-api';

const MARKER_TYPES: Partial<Record<string, MarkerType>> = {
  [FEATURE_TYPE.PIN_ICON_MARKER]: 'pin',
  [FEATURE_TYPE.SURFACE_MARKER]: 'surface',
  [FEATURE_TYPE.LINE_MARKER]: 'line',
  [FEATURE_TYPE.POLYGON_MARKER]: 'polygon',
  [FEATURE_TYPE.TEXT_MARKER]: 'text',
  [FEATURE_TYPE.IMAGE_MARKER]: 'image',
};

/**
 * Translates the clicked map feature into the `target` reported by the plugin onMapClick event.
 * A search result pin is reported as the element it is drawn for, as it carries that element's id.
 */
export const getMapClickTarget = (feature: FeatureLike | undefined): MapClickTarget | null => {
  if (!feature) {
    return null;
  }
  const type = feature.get('type');
  const id = feature.get('id');

  switch (type) {
    case FEATURE_TYPE.ALIAS:
    case FEATURE_TYPE.GLYPH:
    case FEATURE_TYPE.COMPARTMENT:
    case FEATURE_TYPE.PIN_ICON_BIOENTITY:
      return { type: 'element', id: Number(id) };
    case FEATURE_TYPE.REACTION:
      return { type: 'reaction', id: Number(id) };
    case FEATURE_TYPE.PIN_ICON_COMMENT:
      return { type: 'comment', id: Number(id) };
    case FEATURE_TYPE.SURFACE_OVERLAY:
      return { type: 'surface', id: id as number | string };
    default: {
      const markerType = MARKER_TYPES[type];
      return markerType ? { type: 'marker', markerType, id: String(id) } : null;
    }
  }
};
